var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlumni1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 277,
    viewBox: "0 0 202 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2253_818",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 202,
    height: 277
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.685059,
    width: 201.785,
    height: 275.685,
    fill: "#147D76"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2253_818)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -66.311,
    y: -0.289307,
    width: 303.747,
    height: 276.659,
    fill: "#147D76"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202 199H128.132V135.885H64.066V72.771H0V0H19.604V53.4581H83.67V116.573H147.736V179.687H202V199Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7305 167.407C99.0519 167.407 100.934 165.525 100.934 163.204C100.934 160.882 99.0519 159 96.7305 159C94.409 159 92.527 160.882 92.527 163.204C92.527 165.525 94.409 167.407 96.7305 167.407Z",
    fill: "#15625D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7305 185.284C99.0519 185.284 100.934 183.402 100.934 181.081C100.934 178.759 99.0519 176.877 96.7305 176.877C94.409 176.877 92.527 178.759 92.527 181.081C92.527 183.402 94.409 185.284 96.7305 185.284Z",
    fill: "#15625D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7305 203.162C99.0519 203.162 100.934 201.28 100.934 198.958C100.934 196.636 99.0519 194.754 96.7305 194.754C94.409 194.754 92.527 196.636 92.527 198.958C92.527 201.28 94.409 203.162 96.7305 203.162Z",
    fill: "#15625D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7305 221.038C99.0519 221.038 100.934 219.156 100.934 216.835C100.934 214.513 99.0519 212.631 96.7305 212.631C94.409 212.631 92.527 214.513 92.527 216.835C92.527 219.156 94.409 221.038 96.7305 221.038Z",
    fill: "#15625D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7305 238.939C99.0519 238.939 100.934 237.057 100.934 234.735C100.934 232.413 99.0519 230.531 96.7305 230.531C94.409 230.531 92.527 232.413 92.527 234.735C92.527 237.057 94.409 238.939 96.7305 238.939Z",
    fill: "#15625D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9785 167.407C63.3 167.407 65.1819 165.525 65.1819 163.204C65.1819 160.882 63.3 159 60.9785 159C58.657 159 56.7751 160.882 56.7751 163.204C56.7751 165.525 58.657 167.407 60.9785 167.407Z",
    fill: "#15625D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9785 185.284C63.3 185.284 65.1819 183.402 65.1819 181.081C65.1819 178.759 63.3 176.877 60.9785 176.877C58.657 176.877 56.7751 178.759 56.7751 181.081C56.7751 183.402 58.657 185.284 60.9785 185.284Z",
    fill: "#15625D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9785 203.162C63.3 203.162 65.1819 201.28 65.1819 198.958C65.1819 196.636 63.3 194.754 60.9785 194.754C58.657 194.754 56.7751 196.636 56.7751 198.958C56.7751 201.28 58.657 203.162 60.9785 203.162Z",
    fill: "#15625D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9785 221.038C63.3 221.038 65.1819 219.156 65.1819 216.835C65.1819 214.513 63.3 212.631 60.9785 212.631C58.657 212.631 56.7751 214.513 56.7751 216.835C56.7751 219.156 58.657 221.038 60.9785 221.038Z",
    fill: "#15625D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9785 238.939C63.3 238.939 65.1819 237.057 65.1819 234.735C65.1819 232.413 63.3 230.531 60.9785 230.531C58.657 230.531 56.7751 232.413 56.7751 234.735C56.7751 237.057 58.657 238.939 60.9785 238.939Z",
    fill: "#15625D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2034 167.407C27.5249 167.407 29.4068 165.525 29.4068 163.204C29.4068 160.882 27.5249 159 25.2034 159C22.8819 159 21 160.882 21 163.204C21 165.525 22.8819 167.407 25.2034 167.407Z",
    fill: "#15625D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2034 185.284C27.5249 185.284 29.4068 183.402 29.4068 181.081C29.4068 178.759 27.5249 176.877 25.2034 176.877C22.8819 176.877 21 178.759 21 181.081C21 183.402 22.8819 185.284 25.2034 185.284Z",
    fill: "#15625D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2034 203.162C27.5249 203.162 29.4068 201.28 29.4068 198.958C29.4068 196.636 27.5249 194.754 25.2034 194.754C22.8819 194.754 21 196.636 21 198.958C21 201.28 22.8819 203.162 25.2034 203.162Z",
    fill: "#15625D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2034 221.038C27.5249 221.038 29.4068 219.156 29.4068 216.835C29.4068 214.513 27.5249 212.631 25.2034 212.631C22.8819 212.631 21 214.513 21 216.835C21 219.156 22.8819 221.038 25.2034 221.038Z",
    fill: "#15625D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2034 238.939C27.5249 238.939 29.4068 237.057 29.4068 234.735C29.4068 232.413 27.5249 230.531 25.2034 230.531C22.8819 230.531 21 232.413 21 234.735C21 237.057 22.8819 238.939 25.2034 238.939Z",
    fill: "#15625D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0794 167.407C45.4009 167.407 47.2828 165.525 47.2828 163.204C47.2828 160.882 45.4009 159 43.0794 159C40.7579 159 38.876 160.882 38.876 163.204C38.876 165.525 40.7579 167.407 43.0794 167.407Z",
    fill: "#15625D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0794 185.284C45.4009 185.284 47.2828 183.402 47.2828 181.081C47.2828 178.759 45.4009 176.877 43.0794 176.877C40.7579 176.877 38.876 178.759 38.876 181.081C38.876 183.402 40.7579 185.284 43.0794 185.284Z",
    fill: "#15625D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0794 203.162C45.4009 203.162 47.2828 201.28 47.2828 198.958C47.2828 196.636 45.4009 194.754 43.0794 194.754C40.7579 194.754 38.876 196.636 38.876 198.958C38.876 201.28 40.7579 203.162 43.0794 203.162Z",
    fill: "#15625D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0794 221.038C45.4009 221.038 47.2828 219.156 47.2828 216.835C47.2828 214.513 45.4009 212.631 43.0794 212.631C40.7579 212.631 38.876 214.513 38.876 216.835C38.876 219.156 40.7579 221.038 43.0794 221.038Z",
    fill: "#15625D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0794 238.939C45.4009 238.939 47.2828 237.057 47.2828 234.735C47.2828 232.413 45.4009 230.531 43.0794 230.531C40.7579 230.531 38.876 232.413 38.876 234.735C38.876 237.057 40.7579 238.939 43.0794 238.939Z",
    fill: "#15625D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8544 167.407C81.1759 167.407 83.0578 165.525 83.0578 163.204C83.0578 160.882 81.1759 159 78.8544 159C76.5329 159 74.6511 160.882 74.6511 163.204C74.6511 165.525 76.5329 167.407 78.8544 167.407Z",
    fill: "#15625D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8544 185.284C81.1759 185.284 83.0578 183.402 83.0578 181.081C83.0578 178.759 81.1759 176.877 78.8544 176.877C76.5329 176.877 74.6511 178.759 74.6511 181.081C74.6511 183.402 76.5329 185.284 78.8544 185.284Z",
    fill: "#15625D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8544 203.162C81.1759 203.162 83.0578 201.28 83.0578 198.958C83.0578 196.636 81.1759 194.754 78.8544 194.754C76.5329 194.754 74.6511 196.636 74.6511 198.958C74.6511 201.28 76.5329 203.162 78.8544 203.162Z",
    fill: "#15625D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8544 221.038C81.1759 221.038 83.0578 219.156 83.0578 216.835C83.0578 214.513 81.1759 212.631 78.8544 212.631C76.5329 212.631 74.6511 214.513 74.6511 216.835C74.6511 219.156 76.5329 221.038 78.8544 221.038Z",
    fill: "#15625D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8544 238.939C81.1759 238.939 83.0578 237.057 83.0578 234.735C83.0578 232.413 81.1759 230.531 78.8544 230.531C76.5329 230.531 74.6511 232.413 74.6511 234.735C74.6511 237.057 76.5329 238.939 78.8544 238.939Z",
    fill: "#15625D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlumni1);
export default __webpack_public_path__ + "static/media/alumni1.d336422e20bbab75f2019ddf1d5b53d4.svg";
export { ForwardRef as ReactComponent };